document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll(".mega-menu__linklist > li");

    const firstItem = items[0];
    const secondItem = items[1];

    let secondUnlocked = false;

    items.forEach(function (item, index) {

        const heading = item.querySelector(":scope > a.h6");
        const submenu = item.querySelector(":scope > ul");

        if (!heading || !submenu) return;

        // Create heading wrapper
        const wrapper = document.createElement("div");
        wrapper.className = "accordion-heading";

        // Create icon
        const icon = document.createElement("span");
        icon.className = "accordion-icon";
        icon.innerHTML = index === 0 ? "−" : "+";

        // Wrap heading
        heading.parentNode.insertBefore(wrapper, heading);
        wrapper.appendChild(heading);
        wrapper.appendChild(icon);

        // DEFAULT STATE
        if (index === 0) {
            item.style.display = "block";
            submenu.style.display = "block";
        } else {
            item.style.display = "none";
        }

        // Accordion toggle (normal behavior)
        icon.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

            const isOpen = submenu.style.display === "block";

            // Close all
            items.forEach(function (otherItem) {

                const otherMenu = otherItem.querySelector(":scope > ul");
                const otherIcon = otherItem.querySelector(".accordion-icon");

                if (otherMenu) otherMenu.style.display = "none";
                if (otherIcon) otherIcon.innerHTML = "+";

            });

            if (!isOpen) {
                submenu.style.display = "block";
                icon.innerHTML = "−";
            }

        });

    });

    // ----------------------------
    // ESTATE RANGE → SHOW 2ND
    // ----------------------------

    if (firstItem && secondItem) {

        const firstMenu = firstItem.querySelector(":scope > ul");

        const estateLi = document.createElement("li");
        estateLi.innerHTML = `
            <a href="#" class="estate-range-link h6">The Estate Range</a>
        `;

        firstMenu.appendChild(estateLi);

        estateLi.querySelector("a").addEventListener("click", function (e) {

            e.preventDefault();

            secondUnlocked = true;

            // close all
            items.forEach(function (otherItem) {
                const otherMenu = otherItem.querySelector(":scope > ul");
                const otherIcon = otherItem.querySelector(".accordion-icon");

                if (otherMenu) otherMenu.style.display = "none";
                if (otherIcon) otherIcon.innerHTML = "+";
            });

            // show 2nd accordion
            secondItem.style.display = "block";

            const secondMenu = secondItem.querySelector(":scope > ul");
            const secondIcon = secondItem.querySelector(".accordion-icon");

            if (secondMenu) secondMenu.style.display = "block";
            if (secondIcon) secondIcon.innerHTML = "−";

            secondItem.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });

        });

    }

    // ----------------------------
    // WISHART JEWELLERY → BACK TO 1ST
    // ----------------------------

    function addWishartHandler() {

        if (!secondItem) return;

        const secondMenu = secondItem.querySelector(":scope > ul");

        if (!secondMenu) return;

        const lastLi = document.createElement("li");

        lastLi.innerHTML = `
            <a href="#" class="wishart-link h6">Wishart Jewellers</a>
        `;

        secondMenu.appendChild(lastLi);

        lastLi.querySelector("a").addEventListener("click", function (e) {

            e.preventDefault();

            // reset second
            secondItem.style.display = "none";

            const secondMenuInner = secondItem.querySelector(":scope > ul");
            const secondIcon = secondItem.querySelector(".accordion-icon");

            if (secondMenuInner) secondMenuInner.style.display = "none";
            if (secondIcon) secondIcon.innerHTML = "+";

            // open first accordion again
            items.forEach(function (otherItem, index) {

                const otherMenu = otherItem.querySelector(":scope > ul");
                const otherIcon = otherItem.querySelector(".accordion-icon");

                if (index === 0) {
                    otherItem.style.display = "block";
                    if (otherMenu) otherMenu.style.display = "block";
                    if (otherIcon) otherIcon.innerHTML = "−";
                } else {
                    otherItem.style.display = "none";
                }

            });

            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });

        });

    }

    addWishartHandler();

});

document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', function () {
        document.body.classList.toggle('hide-announcement', window.scrollY > 50);
    });
});


// This is popup js
(function () {
      var END_DATE   = new Date('2026-11-08T15:00:00+10:30'); // stops showing after the event (Adelaide time)
      var DELAY_MS   = 2000;                                   // wait 2s after page load
      var HIDE_DAYS  = 1;                                      // after closing, don't show again for 1 day
      var KEY        = 'wjExhibitionPopupClosed';

      if (new Date() > END_DATE) return;

      var popup = document.getElementById('wjPopup');
      var closeBtn = document.getElementById('wjPopupClose');
      if (!popup) return;

      try {
        var closedAt = localStorage.getItem(KEY);
        if (closedAt && Date.now() - Number(closedAt) < HIDE_DAYS * 864e5) return;
      } catch (e) {}

      function show() { popup.classList.add('is-visible'); popup.setAttribute('aria-hidden', 'false'); }
      function hide() {
        popup.classList.remove('is-visible'); popup.setAttribute('aria-hidden', 'true');
        try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      }

      closeBtn.addEventListener('click', hide);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });

      if (document.readyState === 'complete') setTimeout(show, DELAY_MS);
      else window.addEventListener('load', function () { setTimeout(show, DELAY_MS); });
    })();